module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAolBMVEUAAAAAAAAAAIAAVaoAVaoAVcYAXbkRVbsNWb8MXbkOYMEQYsMSZL8TY8ITZb8TZMISZMERY78RZMARZL8SZMASZL8SZMESZb8TZb8SZcATZMATZcETY8ATZMATZMAUZcATZb8TZcATZMATZcATZb8UZcATZMATZb8UZMAUZb8UZMATZb8TZcAUZcAUZcATZL8TZMATZMATZcATZcATZMAUZcCmcNW5AAAANXRSTlMAAQIDBgkLDxQWJS84Q0RPV1hZXGFwc3R8fpKTn6Gjqqyvur7Aw8XIz9DR5Obp6+zy+fr9/knwVfkAAABxSURBVBgZrcHFAoJQFEXRrT67MLEDu/P8/68pTrjglLVIRaa7uxx8R8xEoZXDaEkbfykNMdba5mCmE8ZVfaAplYicNQJ6UoHIXI92vn7TEaP21k8Ha6HQPotVeeqrQdxYUkBC+a5XlaSBpvxxXpGUfAAUpg2VaPFxmQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/icon-site.png
// module id = UM7X
// module chunks = 1